import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';
import { AuthShell } from '../../components/auth/AuthShell';
import { postJson } from '../../lib/authFlows';

export default function VerifyEmailPage({ apiBase, loginPath, variant }) {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: 'loading', message: '' });
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    postJson(`${apiBase}/verify-email`, { token: params.get('token') })
      .then(d => setState({ status: 'ok', message: `${d.message} Hesabınız admin onayından sonra aktif olacaktır.` }))
      .catch(e => setState({ status: 'error', message: e.message }));
  }, [apiBase, params]);

  const Icon = state.status === 'ok' ? CheckCircle2 : state.status === 'error' ? XCircle : Loader2;
  return (
    <AuthShell variant={variant} loginPath={loginPath} testId="verify-email-page" title="E-posta onayı">
      <div className="flex flex-col items-center text-center gap-3 py-4" data-testid={`verify-email-${state.status}`}>
        <Icon className={`h-12 w-12 ${state.status === 'ok' ? 'text-emerald-500' : state.status === 'error' ? 'text-red-500' : 'animate-spin text-slate-400'}`} />
        <p className={`text-sm ${variant === 'hesap' ? 'text-slate-300' : ''}`}>{state.status === 'loading' ? 'Onaylanıyor...' : state.message}</p>
      </div>
    </AuthShell>
  );
}
